import { render, staticRenderFns } from "./text-type.vue?vue&type=template&id=1d4cf9a3&scoped=true&lang=pug&"
import script from "./text-type.vue?vue&type=script&lang=ts&"
export * from "./text-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4cf9a3",
  null
  
)

export default component.exports